import { StringFilterUI } from '@syncfusion/ej2-vue-grids'

export interface SearchIAParams {
  search: string
  expedientName?: string
  contactName?: string
}

export const FilterTypes = {
  GENERAL: 'general',
  EXPEDIENT: 'expedient',
  CONTACT: 'contact'
} as const

export type FilterType = typeof FilterTypes[keyof typeof FilterTypes]

export interface FilterOption {
  id: FilterType
  label: string
  description: string | null
  icon: string
  selectedText?: string
}

export interface IAResultChunk {
  chunk_id: string
  chunk_index: number
  position: string
  overlap: number
  kind: string
  distance?: number
  chunk?: string
  title?: string
  file_name?: string
  file_path?: StringFilterUI
}

export interface IAResultDocument {
  idDocument: number
  folder: string
  idEntityType: number
  idEntity: number
  documentName: string
  documentFile: string
  desciptionExpedient: string
  actionName: string
  idExpedient: string
  idOwnFile: string
  idCustomer: string
  customer: string
  contact: string
  chunks: IAResultChunk[]
}

export interface IAResult {
  generated_response?: string
  retrieved_documents: IAResultDocument[]
  retrieved_chunks: IAResultChunk[]
  performance?: {
    weaviate_time_seconds?: number
    openai_time_seconds?: number
    total_time_seconds?: number
  }
}

export interface AdvanceSearchLikeParams {
  question: string
}

export interface AdvanceSearchDislikeParams extends AdvanceSearchLikeParams {
  opinion: string
}
